
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator';
import Avatar from 'vue3-avatar';
import { AppColorSettingsInfo } from '@/entities/Application/AppColorSettingsInfo';
import { StoreHelper } from '@/store/StoreHelper';
import { Store } from '@/main';

@Component({
  components: {
    Avatar,
  },
})
class EntityHeader extends Vue {
  @Prop() size!: number;
  @Prop() title?: string = '';
  @Prop() description?: string;

  // For avatar initials
  @Prop() firstName?: string;
  @Prop() lastName?: string;

  // For image
  @Prop() imageUrl?: string;

  private storeHelper = new StoreHelper(Store);
  private defaultIcon = require('@/assets/Images/default-user-icon.svg');

  // ✅ Check IconUrl is Valid or not (same as yours)
  private IsIconUrlValid() {
    return !!this.imageUrl;
  }
  private HasName() {
    return !!this.firstName;
  }
  // ✅ get by default color for Background color
  private GetDefaultBackgroundColor() {
    const appDefaultColorsInfo: AppColorSettingsInfo = this.storeHelper.GetApplicationColorSettingsFromStore();
    return appDefaultColorsInfo.topNavBackgroundColor;
  }

  // ✅ get by default color for Foreground color
  private GetDefaultForegroundColor() {
    const appDefaultColorsInfo: AppColorSettingsInfo = this.storeHelper.GetApplicationColorSettingsFromStore();
    return appDefaultColorsInfo.topNavForegroundColor;
  }

  // Get Intials for avtar
  private GetIntials(firstName: string, lastName: string) {
    if(lastName !== '') {
      return firstName.charAt(0) + ' ' + lastName.charAt(0);
    } else {
      return firstName.charAt(0);
    }
  }
}
export default toNative(EntityHeader);
